/** Simple loading service to trigger alerts in App.tsx */

type SetAlert = (alert: JSX.Element) => void;

let _setAlert: SetAlert;

export function initializePageAlert(setAlert: SetAlert): void {
    _setAlert = setAlert;
}

export function setPageAlert(alert: JSX.Element): void {
    if (!alert) console.warn('You are attempting to clear an alert manually, please use clearPageAlert()');
    _setAlert(alert);
}

export function clearPageAlert(): void {
    _setAlert(undefined);
}

export default { initializePageAlert, setPageAlert };
